export { default } from "./HandsignTutorial";
